import React from 'react'

const InputContext = React.createContext({})

export default InputContext
